// src/components/LoadingBox/LoadingBox.tsx (o donde lo tengas ubicado)
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

// No es necesario definir interfaces de props si el componente no recibe ninguna.
// React.FC ya es suficiente para tipar un componente funcional sin props específicas.

const LoadingBox: React.FC = () => {
  return (
    <div>
      {/* Utiliza el icono directamente */}
      <FontAwesomeIcon icon={faSpinner} spin />{" "}
      {/* Añadí 'spin' para que el icono gire */}
      Loading..
    </div>
  );
};

export default LoadingBox;
// Este componente LoadingBox ahora es más simple y directo.
